import React from "react"
import { paginationButtonStyle } from "../styles/commonStyles"
import { getPaginationInfo, getPaginationPages } from "../utils/helpers"
import { COLORS, TYPOGRAPHY } from "../constants/theme"

const PaginationControls = ({ currentPage, totalPages, totalCount, perPage, isLoading, onPageChange }) => {
	const { showingText } = getPaginationInfo(currentPage, perPage, totalCount)
	const pages = getPaginationPages(currentPage, totalPages)

	if (totalPages <= 1) return null

	const handlePageChange = (page) => {
		if (page !== currentPage && page >= 1 && page <= totalPages && !isLoading) {
			onPageChange(page)
		}
	}

	const renderPageButton = (pageItem) => {
		if (pageItem.type === "ellipsis") {
			return (
				<span
					key={pageItem.key}
					style={{
						padding: "6px",
						color: COLORS.gray400,
						fontSize: TYPOGRAPHY.fontSize.sm,
					}}
				>
					...
				</span>
			)
		}

		const isActive = pageItem.page === currentPage

		return (
			<button key={pageItem.key} onClick={() => handlePageChange(pageItem.page)} disabled={isLoading} style={paginationButtonStyle(isLoading, isActive)}>
				{pageItem.page}
			</button>
		)
	}

	return (
		<div
			style={{
				display: "flex",
				justifyContent: "space-between",
				alignItems: "center",
				padding: "16px 0",
				borderTop: `1px solid ${COLORS.border}`,
				marginTop: "16px",
				flexWrap: "wrap",
				gap: "12px",
			}}
		>
			{/* Showing info */}
			<div
				style={{
					fontSize: TYPOGRAPHY.fontSize.sm,
					color: COLORS.gray600,
					minWidth: "fit-content",
				}}
			>
				{showingText}
			</div>

			{/* Pagination controls */}
			<div
				style={{
					display: "flex",
					gap: "8px",
					alignItems: "center",
					flexWrap: "wrap",
				}}
			>
				{/* Previous button */}
				<button
					onClick={() => handlePageChange(currentPage - 1)}
					disabled={currentPage === 1 || isLoading}
					style={paginationButtonStyle(currentPage === 1 || isLoading)}
				>
					<svg width="16" height="16" viewBox="0 0 24 24" fill="none">
						<path d="M15 18l-6-6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
					</svg>
					ก่อนหน้า
				</button>

				{/* Page numbers */}
				{pages.map(renderPageButton)}

				{/* Next button */}
				<button
					onClick={() => handlePageChange(currentPage + 1)}
					disabled={currentPage === totalPages || isLoading}
					style={paginationButtonStyle(currentPage === totalPages || isLoading)}
				>
					ถัดไป
					<svg width="16" height="16" viewBox="0 0 24 24" fill="none">
						<path d="M9 18l6-6-6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
					</svg>
				</button>
			</div>
		</div>
	)
}

export default PaginationControls
